var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "dashboard-block" }, [
    _c("h2", [_vm._v("Share Your Profile")]),
    _vm._v(" "),
    _c("div", { staticClass: "panel panel-grey" }, [
      _c("div", { staticClass: "panel-body" }, [
        _c("p", [
          _vm._v(
            "Your followers want to know that you're available to book. Share your profile on your socials."
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "flex" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.user.social_share_link,
                expression: "user.social_share_link",
              },
            ],
            ref: "copy_input",
            staticClass: "w-full margin-r-1",
            attrs: {
              type: "text",
              id: "copy_input",
              name: "copy_input",
              readonly: "readonly",
            },
            domProps: { value: _vm.user.social_share_link },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.user, "social_share_link", $event.target.value)
              },
            },
          }),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-primary pull-right",
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                },
                click: _vm.handleCopySocialLink,
                mouseout: () => {
                  this.copied = false
                },
              },
            },
            [_vm._v("\n          " + _vm._s(_vm.tooltipText) + "\n        ")]
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }